<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <ShowcaseOffersApproval
                        v-if="offer.siteName"
                        :offer-name="offer.siteName"
                        :param-name="offer.params.approval?.name"
                        :param-value="offer.params.approval?.string"
                    />
                    <div class="lds-widget-card__params">
                        <div
                            class="lds-widget-card__block"
                            v-if="offer.params.amount || isVisibleBlockInTopPositionByWidth(offer, desktopPlacement, containerWidth)"
                        >
                            <ShowcaseOfferParams
                                v-if="offer.params.amount"
                                :name="offer.params.amount.name"
                                :value="offer.params.amount.string"
                                :class="['lds-widget-card__item_big', 'lds-widget-card__item_sum', {'lds-widget-card__item_big-xs': offer.params.amount.range}]"
                                :symbol="currencySymbol"
                            />
                        </div>
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.period"
                                :name="offer.params.period.name"
                                :value="offer.params.period.string"
                                class="lds-widget-card__item_period"
                                :symbol="periodSymbol"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.age"
                                :name="offer.params.age.name"
                                :value="offer.params.age.string"
                                class="lds-widget-card__item_age"
                                symbol="лет"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import { inject } from 'vue';
import { isVisibleBlockInTopPositionByWidth } from '../../common/function.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOffersApproval from '../ShowcaseOfferParams/ShowcaseOffersApproval.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
// import { cookieStore } from '@/scripts/cookie.ts';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';
import { useContainerWidth } from '../../../composables/useContainerWidth.js';
import offerPeriodSymbol from '../../common/offerPeriodSymbol.js';

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const currencySymbol = inject('currencySymbol');
const { offerClasses } = showcaseOfferClasses(props);
const periodSymbol = offerPeriodSymbol(props.offer.offerCategories);

function transformUrl(url) {
    return cookieStore.transformUrl(url);
}

// container queries
const widgetId = inject('widgetId');
const widgetType = inject('widgetType');
const widgetMode = inject('widgetMode');

const { containerWidth } = useContainerWidth(widgetId, widgetType, widgetMode);

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>